import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ element, rights, allowedRights }) => {
  const auth = useSelector((state) => state.authentication);
  const rightsRedux = auth.userData.rights;
  const tempoToken = auth.userData.token;

  if (tempoToken === "undefined" || tempoToken === null || !tempoToken) {
    return <Navigate to="/" replace />;
  }

  const hasPermission = allowedRights.includes(rightsRedux);

  return hasPermission ? element : <Navigate to="/unauthorized" replace />;
};

export default ProtectedRoute;
